import { render, staticRenderFns } from "./CompanyOnboardingSideMenu.vue?vue&type=template&id=55997774&scoped=true"
import script from "./CompanyOnboardingSideMenu.vue?vue&type=script&lang=js"
export * from "./CompanyOnboardingSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyOnboardingSideMenu.vue?vue&type=style&index=0&id=55997774&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55997774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55997774')) {
      api.createRecord('55997774', component.options)
    } else {
      api.reload('55997774', component.options)
    }
    module.hot.accept("./CompanyOnboardingSideMenu.vue?vue&type=template&id=55997774&scoped=true", function () {
      api.rerender('55997774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyOnboardingSideMenu.vue"
export default component.exports